module.exports = "<div class=modal__container> <div ng-transclude=header></div> <div ng-transclude=content></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal.template.html
// module id = 564
// module chunks = 0